import { KeyValue } from "@angular/common";

export class UdeuTransferCalendar {
    id: string;
    name: string;
    data: UdeuData;
    recipients: UdeuRecipient[];

    constructor() {
        this.data = new UdeuData();
        this.recipients = [];
    }
}

export class UdeuData {
    structure: string | KeyValue<string, string>;
    month: string | KeyValue<string, string>;
    fortnight: string | KeyValue<string, string>;
    course: string;
    active: boolean;
    dates: string;
    datesEU: string;
}

export class UdeuRecipient {
    gaudeId?: string;
    unit?: string;
    name: string;
    email: string;
    toNotify: boolean;
}